<template>
  <b-modal
    size="lg"
    id="modal-list-voice"
    :title="$t('rjm.join') + ' Audio'"
    centered
    @show="
      isModalOpen = true
      tableKey += 1
    "
    @hidden="isModalOpen = false"
    data-me="rjm-component-modal-list-voice"
  >
    <div class="table-responsive my-3" v-if="isModalOpen">
      <McGraphqlEditableTable
        ref="tableVoice"
        :key="tableKey"
        :fields="fields"
        :apiClient="query"
        trackBy="id"
        :searchable="true"
        :isPredefined="true"
        :fieldException="['audioFileUrl']"
        data-me="rjm-component-modal-list-voice-table"
      >
        <template #addButton="{ handleAdd }">
          <McButton
            variant="primary"
            :text="$t('global.addField') + ' Audio'"
            icon="icon-fill_download"
            @click="addAudio(handleAdd)"
            v-if="hasAccessAll(['d9a-default-voice-announcer:create'])"
            data-me="rjm-component-modal-list-voice-button-add-audio"
          />
        </template>
        <template #cell(audioFileUrl)="{ item }">
          <McButton
            variant="secondary"
            class="ms-2"
            size="small"
            icon="icon-outline_volume-up"
            text="Tes Audio"
            @click="modalPlayVoice(item)"
            data-me="rjm-component-modal-list-voice-button-test-audio"
          />
        </template>
        <!-- <template #audioFileUrl-edit="{ item }">
          <McButton
            variant="secondary"
            class="ms-2"
            size="small"
            icon="icon-outline_volume-up"
            text="Tes Audio"
            @click="modalPlayVoice(item)"
            data-me="rjm-component-modal-list-voice-button-test-audio-edit"
          />
        </template> -->
      </McGraphqlEditableTable>
    </div>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn mt-0">
          <McButton
            variant="outline-primary"
            @click="cancel()"
            class="me-2"
            :text="$t('global.action.close')"
            data-me="rjm-component-modal-list-voice-button-close"
          />
        </b-col>
      </b-row>
    </template>
    <ModalPlayVoice ref="modalPlayVoice" />
    <ModalAddVoice ref="modalAddVoice" @success="handleUploadSuccess" />
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import ModalPlayVoice from './ModalPlayVoice'
import ModalAddVoice from './ModalAddVoice'
import {
  getAudioFiles,
  createAudioFile,
  deleteAudioFile,
  updateAudioFile,
} from '@/services/api/master/rjm'

export default {
  name: 'ModalListVoice',

  components: { McGraphqlEditableTable, McButton, ModalPlayVoice, ModalAddVoice },
  mixins: [Helper],
  data() {
    return {
      data: [],
      beLimitMessage: false,
      isModalOpen: false,
      tableKey: 0,
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'label',
          label: this.$t('rjm.nameAudio'),
          placeholder: this.$t('rjm.nameAudio'),
          isSortable: true,
          editable: true,
          validation: [['required'], ['isUnique', this.data]],
        },
        {
          key: 'audioFileUrl',
          label: 'Audio',
          isSortable: false,
          editable: false,
          customColumn: true,
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          if (filter?.orderBy) {
            let objOrderBy = JSON.parse(filter.orderBy[0])
            let optOrderBy = {
              label: objOrderBy.label,
            }
            delete filter.orderBy[0]
            filter.orderBy[0] = JSON.stringify(optOrderBy)
          }
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: getAudioFiles,
            variables: {
              filter: filter,
            },
          })
          const audioFilesResponse = res.data.audioFiles
          if (audioFilesResponse.message === 'Company already have 10 audio files') {
            this.beLimitMessage = true
          } else {
            this.beLimitMessage = false
          }
          const result = audioFilesResponse.audioFiles
          result.data.forEach((item, index) => {
            result.data[index].id = item.audioFileId
            result.data[index].label = item.label || ''
            if (item.companyId == 1) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = false
              result.data[index].isShowDelete = false
            }
          })

          this.data = result.data
          return result
        },
        store: async (data) => {
          const res = await this.$apollo.mutate({
            mutation: createAudioFile,
            variables: {
              input: {
                label: data.label,
              },
            },
          })
          if (!res.data.uploadAudioFile.isSuccessful) {
            if (res.data.uploadAudioFile.message === 'Company already have 10 audio files') {
              this.$bvModal.show('modal-audio-full')
              return
            }
          }
          const newData = res.data.uploadAudioFile.uploadAudioFile
          newData.id = newData.audioFileId
          this.data.push(newData)

          return newData
        },
        update: async (name, oldData, newData) => {
          const res = await this.$apollo.mutate({
            mutation: updateAudioFile,
            variables: {
              input: {
                audioFileId: oldData.id,
                label: newData.label,
              },
            },
          })
          const dataUpdateIndex = this.data.findIndex((item) => item.id == oldData.id)
          const result = res.data.updateAudioFile.updateAudioFile
          result.id = result.audioFileId
          this.data[dataUpdateIndex] = result
          return result
        },
        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: deleteAudioFile,
            variables: {
              input: {
                audioFileIds: [id],
              },
            },
          })

          if (res.data.deleteAudioFiles.isSuccessful) {
            const dataDeleteIndex = this.data.findIndex((val) => val.id == id)
            if (dataDeleteIndex !== -1) {
              this.data.splice(dataDeleteIndex, 1)
            }
            return true
          } else {
            const message = res.data.deleteAudioFiles.message
            if (message === 'Audio file is connected to a Voice Announcer') {
              this.$mcToast.error(this.$t('rjm.errorDeleteAudioConnected'))
              return 'HANDLED_ERROR'
            }
            return false
          }
        },
      }
    },

    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
  },

  methods: {
    handleUploadSuccess() {
      if (this.$refs.tableVoice) {
        setTimeout(() => {
          this.$refs.tableVoice.getData({
            limit: this.$refs.tableVoice.limit,
            page: 1,
            sorts: this.$refs.tableVoice.stringSorts(),
          })
        }, 500)
      }
    },

    modalPlayVoice(item) {
      this.$refs.modalPlayVoice.show(item)
    },

    addAudio(handleAdd) {
      const userAudioCount = this.data.filter((item) => item.companyId != 1).length
      if (userAudioCount >= 10 || this.beLimitMessage) {
        this.$bvModal.show('modal-audio-full')
      } else {
        this.$bvModal.show('modal-add-voice')
      }
    },
  },
}
</script>
